import { Icon } from '../../components/ui/Icon';
import type {
  Role,
  PermissionMatrix,
  Suite,
} from '../../data/types/platform';

export interface AdminPermsProps {
  roles: Role[];
  perms: PermissionMatrix;
  suites: Suite[];
}

export function AdminPerms({ roles, perms, suites }: AdminPermsProps) {
  return (
    <div className="admin-perms">
      <div className="admin-section-head">
        <h2>מטריצת הרשאות</h2>
        <span className="cell-dim">תפקיד × מערכת · ניהול / עריכה / צפייה / אין</span>
      </div>
      <div className="perm-matrix-wrap">
        <table className="perm-matrix">
          <thead>
            <tr>
              <th className="row-h">תפקיד</th>
              {suites.map((s) => (
                <th key={s.id}>
                  <div className="perm-col-head">
                    <Icon name={s.icon} size={12} />
                    <span>{s.he}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {roles.map((r) => {
              const rolePerms = perms[r.id] || {};
              return (
                <tr key={r.id}>
                  <td className="row-h">
                    <div className="perm-row-head">
                      <span className={'role-pill-short role-' + r.id}>{r.short}</span>
                      <span>{r.he}</span>
                    </div>
                  </td>
                  {suites.map((s) => {
                    const lvl = rolePerms[s.id];
                    return (
                      <td key={s.id} className={'perm-cell lvl-' + (lvl || 'none')}>
                        {lvl === 'admin' && <span className="perm-mark"><Icon name="shield-check" size={14} /></span>}
                        {lvl === 'edit'  && <span className="perm-mark"><Icon name="pencil" size={14} /></span>}
                        {lvl === 'view'  && <span className="perm-mark"><Icon name="eye" size={14} /></span>}
                        {!lvl && <span className="perm-mark muted">—</span>}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
